<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.locations')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.location.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.location.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="locations"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="location-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="country">{{ t('common.labels.country') }}
                  <p-sortIcon field="country"></p-sortIcon>
              </th>
              <th pSortableColumn="timezone">{{ t('common.labels.timezone') }}
                  <p-sortIcon field="timezone"></p-sortIcon>
              </th>
              <th pSortableColumn="room_count">{{ t('common.labels.rooms') }}
                  <p-sortIcon field="room_count"></p-sortIcon>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-location>
            <tr (click)="onOpen(location)" (keyup.enter)="onOpen(location)" hoverOnRight="admin.location.show" tabindex="0">
              <td><span role="link">{{ location.name }}</span></td>
              <td><span role="link">{{ location.country }}</span></td>
              <td><span role="link">{{ location.timezone }}</span></td>
              <td><span role="link">{{ location.room_count }}</span></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
